import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Button } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import axios from "axios";
import ConfirmationModal from "views/components/ConfirmationModal";
import ToastModal from "views/components/ToastModal";
import { headerLabel } from "assets/properties/properties";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { useNavigate, useOutletContext } from "react-router-dom";
import { loanApplicationStatusNamesList } from "assets/properties/properties";
import { checkForRepledgeAccount } from "utils/Utils";
import { APPLICATION_TYPE_RE_PLEDGE } from "assets/properties/properties";

const Esign = ({ setNext, setBack, loanApplicationId, classes, isEsign, esingDisable, setEsignDisable, closeModal,initiatorType, featureFlags, loanType, prePledgeLoan, editable }) => {
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const navigate = useNavigate();

  const [preview, setPreView] = useState("");
  const [esignLetterState , setEsignLetterState] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [message, setMessage]= useState('');
  const [hideSanctionLetterPartB, setHideSanctionLetterPartB] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [loanAPPLICATIONID, setLoanAPPLICATIONID] = useState("");
  const [enabledInsurance, setEnabledInsurance] = useState(false);
  const parseAndSetFlag = (flag) => {
    return typeof flag === "boolean" ? flag : flag === "true";
  };
    const outletData = featureFlags;
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
  setToast(showToast);
  };
  useEffect(() => {
    getFeatureFlag();
    getInsuranceData();
  }, []);
  const getFeatureFlag = async () => {
    const result = await apiHandler({
      url: endpoint.FEATURE_FLAG,
      method: "GET",
      authToken: authToken,
    });
    setHideSanctionLetterPartB(parseAndSetFlag(result?.data?.hideSanctionLetterPartBFlag));
  };

  const getInsuranceData = async () => {
    const result = await apiHandler({
      url: endpoint.GET_INSURANCE_PREMIUM + loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    setEnabledInsurance(Number(result?.data?.totalPremium) > 0);
  }
  useEffect(() => {
    if(isEsign && !esingDisable){
      const interval = setInterval(async () => {
        const res = await apiHandler({
          url: endpoint.ESIGN_SANCTION_LETTER + loanApplicationId + "/part-a",
          method: "GET",
          authToken: authToken,
        });
        setCallInProgress(false);
        if (res?.data?.status === "DONE" && res?.data?.fileLink) {
         
          setPreView(res?.data?.fileLink)
          clearInterval(interval);
          setEsignDisable(false)
        } else if(res?.data?.status === "REJECTED"){
          setMessage("Your Sanction Letter is Rejected. Please Esign Again");
          setEsignDisable(false)
        }
      },10000);
      return () => {
        clearInterval(interval);
      };
    }else{
      GetSanctionLetter();
    }
  }, []);
  const handleNext = () => {
    if(message){
      toastUpdate("Error", "Sanction Letter has rejected. Please Esign again", true);
    }else if(!preview){
      toastUpdate("Error", "Please Esign or Upload the Sanction Letter", true);
    }else{
    setNext();
    }
  };
  const handleBack = () => {
    setBack();
  };

  const GetEsignSanctionLetter = async()=>{
    if(!esignLetterState){  
      const interval = setInterval(async () => {
      const res = await apiHandler({
        url: endpoint.ESIGN_SANCTION_LETTER + loanApplicationId + "/part-a",
        method: "GET",
        authToken: authToken,
      });
      setCallInProgress(false);
      if (res?.data?.status === "DONE" && res?.data?.fileLink) {
        setPreView(res?.data?.fileLink)
        clearInterval(interval);
        setEsignLetterState(true)
      } else if(res?.data?.status === "REJECTED"){
        setMessage("Your Sanction Letter is Rejected. Please Esign Again");
        setEsignLetterState(true)
      }
    },10000);
    return () => {
      clearInterval(interval);
    };
  }
  }

  const GetSanctionLetter = async () => {
    //SANCTION_LETTER
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.FIND_DOUMENTS + loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.sanctionLetterLink) {
      setPreView(res?.data?.sanctionLetterLink);
    }else{
      GetEsignSanctionLetter();
    }

  };

  const onClickProceedData = async (id) => {
    setCallInProgress(true);
    if (loanType === APPLICATION_TYPE_RE_PLEDGE) {
      const checkResult = await checkForRepledgeAccount(authToken, prePledgeLoan);
      if(checkResult?.data?.error_code){
        toastUpdate("Error",checkResult?.data?.user_description,true);
        return;
      }else{
        const filteredData = checkResult?.data?.filter(item => Number(item?.id) !== Number(id)) || [];
        if (Array.isArray(filteredData) && filteredData.length > 0) {
          const ids = filteredData
            .map(item => item?.id)
            .filter(Boolean);
          const idsText = ids.length > 0 ? ` Lead Ids: ${ids.join(", ")}` : "";
          toastUpdate(
            "Error",
            `Already Repledge Loan Present with ${idsText}`,
            true
          );
          return false;
        }
      }
  }
    const result = await apiHandler({
      url: endpoint.DISBURSAL_APPLICATION_LMS + id + `?newDisbursement=true`,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);;
    } else {
      // GetData();
        navigate("/loanservice/disbursLms", { state: { from: '' } });
    }
  };
  const proceedApplication = () => {
    setConfirmationModalHeader("Disbursal");
    setConfirmationModalMsg(
      "Are you sure you want to Proceed this Loan to LMS"
    );
    setConfirmationModal(true);
    setLoanAPPLICATIONID(loanApplicationId);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setLoanAPPLICATIONID("");
  };
  const handlePositiveResponse = async () => {
    let id = loanAPPLICATIONID;
    handleNegativeResponse();
    // Call API to delete loanMarking
    onClickProceedData(id);
  };
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} style={{ textAlign: "start" }}>
           <SubHeader
                                     label={hideSanctionLetterPartB? headerLabel?.esign : headerLabel?.esignPartA}
                                     subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
                                     onlyLabel/>
        </GridItem>
      </GridContainer>
      
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          {preview ? <iframe src={preview} width="100%" height="500px" />
          :
          <GridItem
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            textAlign: "center",
            marginTop: 50,
          }}
        >
       
          {message? {message} : 
             <>
          <h4>
            Document Send for signing. Please authorize.
          </h4>
          <br />
          <CircularProgresss />
          <br />
          <h6>Do Not refresh this screen.</h6>

          </>
}
        </GridItem>
        }
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} style={{ textAlign: "end" }}>
          <Button
            size="small"
            className={classes.nextButton1}
            disabled={callInProgress}
            onClick={() => handleBack()}
          >
            Back
          </Button>
          <Button
            size="small"
            className={classes.nextButton}
            disabled={callInProgress || initiatorType === 'CUSTOMER' || !preview}
            onClick={() =>
              editable === false
                ? handleNext()
                : hideSanctionLetterPartB
                  ? !enabledInsurance
                    ? proceedApplication()
                    : handleNext()
                  : handleNext()
            }
          >
            {editable === false
            ? "Next"
            : hideSanctionLetterPartB
              ? !enabledInsurance
                ? "Submit"
                : "Next"
              : "Next"}
          </Button>
        </GridItem>
      </GridContainer>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}

      {confirmationModal && (
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
          classes={classes}
        />
      )}
    </div>
  );
};

Esign.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  closeModal: PropTypes.func,
};

export default Esign;
